// removed by extract-text-webpack-plugin
module.exports = {"elapsed-date-value":"_1NoNLKmn0PQffPCYdFXnHO","spin":"_1u8Hdpe_fo2bBS9WJQ9Rmc"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/ElapsedDateTime/styles.scss
// module id = 1659
// module chunks = 18